/* eslint-disable no-useless-escape */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { CLOSE_BTN, DELETE, DOPING_ICON, LINE_GUILD_GRADIENT, TWO_LINE } from 'assets/images'
import { Modal, SearchInput } from 'shared'
import { GUILD_MESSAGE } from 'i18n/constants'
import ModalUserCreateRewardSettingStyled from './styled'
import Button from 'shared/Button'
import SelectCustomCreateRace from 'shared/SelectCustomCreateRace'
import { getImgByKey, getOnlyDecimal, handleAsyncRequest } from 'utils/helper'
import { useAppSelector } from 'hooks'
import InputPrizePool from 'shared/InputPrizePool'
import guildApi from 'apis/guildApi'
import { notification } from 'antd'
import { NUMBER } from 'apps/constants'

interface ModalUserCreateRewardSettingProps {
  toggleIsModalOpen: (value?: boolean) => void
  onCloseButtonClick: () => void
  onConfirmCreateRaceClick: () => void
  isGuildRace?: boolean
  inforEdit: any
}

interface DataItem {
  id: number
  no: number
  itemType: string
  collection: string
  itemName: string
  rarity: string
  quantity: number
  option?: any
}

interface RewardRequest {
  amount: number
  item_type: string
  parent_sub_type: string
  rarity_type?: string
  designated_item?: string
}

const headColumns = [
  {
    title: 'no',
    width: '50px'
  },
  {
    title: 'itemType',
    width: '140px'
  },
  {
    title: 'collection',
    width: '170px'
  },
  {
    title: 'itemName',
    width: '270px'
  },
  {
    title: 'rarity',
    width: '170px'
  },
  {
    title: 'quantity',
    width: '150px'
  },
  {
    title: '',
    width: '50px'
  }
]

function ModalUserCreateRewardSetting({
  onCloseButtonClick,
  onConfirmCreateRaceClick,
  inforEdit
}: ModalUserCreateRewardSettingProps) {
  const [, contextHolder] = notification.useNotification()
  const { t } = useTranslation()
  const [dataList, setDataList] = useState<DataItem[]>([])
  const [rewardCode, setRewardCode] = useState<string>('')
  const { profile } = useAppSelector(state => state)
  const [loadingSubmit, setLoadingSubmit] = useState(false)
  const [, setLoadingPage] = useState(false)
  const [optionItemType] = useState<any[]>(() => {
    const order = ['NFT', 'NFT_TICKET', 'NON_NFT', 'COIN']
    const itemTypeConvertedName = (value: string) => {
      switch (value) {
        case 'NFT':
          return t(`${GUILD_MESSAGE}.nftItems`)
        case 'NON_NFT':
        case 'NON-NFT':
          return t(`${GUILD_MESSAGE}.nonNftItems`)
        case 'COIN':
          return t(`${GUILD_MESSAGE}.coin`)
        case 'NFT_TICKET':
          return t(`${GUILD_MESSAGE}.nftTicket`)
        default:
          return ''
      }
    }
    return order?.map((opt: string) => ({
      name: itemTypeConvertedName(opt),
      isActive: false,
      value: opt
    }))
  })

  useEffect(() => {
    if (!inforEdit) return

    setRewardCode(inforEdit.package_code)

    const rewardItems = inforEdit.rewards_package_dto_list
    if (!rewardItems?.length) return
    if (!optionItemType.length) return
    const getCollectionOptions = async (val: string) => {
      const [error, result]: any = await handleAsyncRequest(guildApi.getOptionCollection(val))
      if (error) return []
      return result?.data?.map((opt: string) => ({
        name: t(`${GUILD_MESSAGE}.${opt.toLowerCase()}`),
        isActive: false,
        value: opt,
        icon: ['COIN', 'NFT_TICKET', 'NFT'].includes(val) ? (
          <img className='mr-2' alt='Merah' src={getImgByKey(opt)} width={25} />
        ) : (
          <img className='mr-2' alt='Merah' src={DOPING_ICON} width={18} />
        )
      }))
    }

    const getItemNameOptions = async (val: string) => {
      const [error, result]: any = await handleAsyncRequest(guildApi.getOptionItemName(val))
      if (error) return []
      return result?.data?.map((opt: string) => ({
        name: opt.toUpperCase(),
        isActive: false,
        value: opt
      }))
    }

    const getItemNameV2Options = async (val: string) => {
      const [error, result]: any = await handleAsyncRequest(guildApi.getOptionItemNameV2(val))
      if (error) return []
      return Object.entries(result.data)?.map((opt: any) => ({
        name: opt?.[0]?.toUpperCase(),
        isActive: false,
        value: opt?.[0],
        icon: (
          <img
            className='mr-2'
            alt='Merah'
            src={opt?.[1]}
            width={25}
            height={25}
            style={{ objectFit: 'contain' }}
          />
        )
      }))
    }

    const getRarityOptions = async (val: string) => {
      const [error, result]: any = await handleAsyncRequest(guildApi.getRarity(val))
      if (error) return []
      return result?.data?.map((opt: any) => ({
        name: opt.display,
        isActive: false,
        value: opt.display,
        icon: <img className='mr-2' alt='Merah' src={getImgByKey(opt.display)} width={25} />
      }))
    }

    const fetchRow = async (rewardItem: any, index: number) => {
      const row: any = {
        id: generateNumericId(),
        no: index + 1,
        option: {
          itemType: [],
          collection: [],
          itemName: [],
          rarity: []
        }
      }
      if (rewardItem.item_type === 'BOOSTER') {
        row.itemType = 'NON-NFT'
        row.collection = rewardItem.parent_sub_type
        row.itemName = rewardItem.designated_item
        row.rarity = ''
        row.quantity = rewardItem.amount
        const [collectionOpt, itemNameOpt] = await Promise.all([
          getCollectionOptions('NON_NFT'),
          getItemNameV2Options(rewardItem.parent_sub_type)
        ])
        row.option = {
          itemType: optionItemType,
          collection: collectionOpt,
          itemName: itemNameOpt,
          rarity: []
        }
      } else if (rewardItem.item_type === 'TICKET') {
        row.itemType = 'NFT TICKET'
        row.collection = rewardItem.parent_sub_type
        row.itemName = ''
        row.rarity = ''
        row.quantity = rewardItem.amount
        const [collectionOpt] = await Promise.all([getCollectionOptions('NFT_TICKET')])
        row.option = {
          itemType: optionItemType,
          collection: collectionOpt,
          itemName: [],
          rarity: []
        }
      } else if (rewardItem.item_type === 'COIN') {
        row.itemType = 'COIN'
        row.collection = rewardItem.parent_sub_type?.replace('_NEW', '')
        row.itemName = ''
        row.rarity = ''
        row.quantity = String(rewardItem.amount)
        const [collectionOpt] = await Promise.all([getCollectionOptions('COIN')])
        row.option = {
          itemType: optionItemType,
          collection: collectionOpt,
          itemName: [],
          rarity: []
        }
      } else {
        // NFT
        row.itemType = 'NFT'
        row.collection = rewardItem.item_type
        row.itemName = rewardItem.parent_sub_type
        row.rarity = rewardItem.rarity_type
        row.quantity = rewardItem.amount
        const [collectionOpt, itemNameOpt, rarityOpt] = await Promise.all([
          getCollectionOptions('NFT'),
          getItemNameOptions(rewardItem.item_type),
          getRarityOptions(rewardItem.parent_sub_type)
        ])
        row.option = {
          itemType: optionItemType,
          collection: collectionOpt,
          itemName: itemNameOpt,
          rarity: rarityOpt
        }
      }
      return row
    }

    ;(async () => {
      const rows = await Promise.all(rewardItems.map((rewardItem: any, index: number) => fetchRow(rewardItem, index)))
      setDataList(rows)
    })()
  }, [inforEdit, optionItemType])

  const renderWidthByField = (field: string) => {
    switch (field) {
      case 'no':
        return { width: '50px', textAlign: 'center' }
      case 'itemType':
        return { width: '140px', textAlign: 'center' }
      case 'collection':
        return { width: '170px', textAlign: 'center' }
      case 'itemName':
        return { width: '270px', textAlign: 'center' }
      case 'rarity':
        return { width: '170px', textAlign: 'center' }
      case 'quantity':
        return { width: '150px', textAlign: 'center' }
      case '':
        return { width: '50px', textAlign: 'center' }
      default:
        return {}
    }
  }

  const _handleKeyDownDay = (e: any, rowId: number) => {
    const currentItemType = dataList.find(item => item.id === rowId)?.itemType
    const key = e.key
    const allowedKeys =
      currentItemType === 'COIN'
        ? ['Backspace', 'Tab', 'Delete', 'ArrowLeft', 'ArrowRight', '.', 'Home', 'End']
        : ['Backspace', 'Tab', 'Delete', 'ArrowLeft', 'ArrowRight', 'Home', 'End']
    const isNumberKey = key >= '0' && key <= '9'
    const isAllowedKey = allowedKeys.includes(key)
    if (!isNumberKey && !isAllowedKey) {
      e.preventDefault()
    }
    if (key === '.' && (e.currentTarget.value.includes('.') || e.currentTarget.selectionStart === 0)) {
      e.preventDefault()
    }
  }

  const handleRemoveItem = (dataId: number) => () => {
    setDataList(prevs => prevs.filter(prev => prev.id !== dataId))
  }

  const renderFieldValue = (rowId: number, fieldName: keyof DataItem) => {
    return dataList?.find((data: DataItem) => data.id === rowId)?.[fieldName] as string
  }

  const renderOptionsValue = (rowId: number, fieldName: keyof DataItem) => {
    const dataRow = dataList.find(data => data.id === rowId)
    return dataRow?.option?.[fieldName]
  }

  const actionSelectValue = async (val: any, rowId: number, fieldName: keyof DataItem) => {
    const currentItemType = dataList.find(item => item.id === rowId)?.itemType
    setDataList(prevs =>
      prevs.map(prev => {
        if (prev.id === rowId) {
          const newPrev = {
            ...prev,
            [fieldName]:
              currentItemType === 'COIN' && typeof val === 'string'
                ? getOnlyDecimal(String(val), NUMBER.NUM_2147483647)
                : typeof val === 'string'
                ? Number(val)
                : val.name
          }
          return newPrev
        }
        return {
          ...prev
        }
      })
    )
    if (fieldName === 'itemType') {
      setLoadingPage(true)
      const [error, result]: any = await handleAsyncRequest(guildApi.getOptionCollection(val.value))
      if (error) {
        setLoadingPage(false)
        return
      }
      if (result) {
        setLoadingPage(false)
        const options = result?.data?.map((opt: string) => ({
          name: t(`${GUILD_MESSAGE}.${opt.toLowerCase()}`),
          isActive: false,
          value: opt,
          icon: ['COIN', 'NFT_TICKET', 'NFT'].includes(val.value) ? (
            <img className='mr-2' alt='Merah' src={getImgByKey(opt)} width={25} />
          ) : (
            <img className='mr-2' alt='Merah' src={DOPING_ICON} width={18} />
          )
        }))
        setDataList(prevs =>
          prevs.map(prev => {
            if (prev.id === rowId) {
              const newPrev = {
                ...prev,
                collection: '',
                itemName: '',
                rarity: '',
                quantity: val.name === 'NFT' ? 1 : 0,
                option: {
                  ...prev.option,
                  collection: options,
                  itemName: [],
                  rarity: []
                }
              }
              return newPrev
            }
            return {
              ...prev
            }
          })
        )
      }
    }
    if (fieldName === 'collection' && !['COIN', 'NFT TICKET'].includes(currentItemType as string)) {
      setLoadingPage(true)
      const [error, result]: any = await handleAsyncRequest(
        currentItemType === 'NFT' ? guildApi.getOptionItemName(val.value) : guildApi.getOptionItemNameV2(val.value)
      )
      if (error) {
        setLoadingPage(false)
        return
      }
      if (result) {
        setLoadingPage(false)
        let options: any = []
        if (currentItemType === 'NFT') {
          options = result?.data?.map((opt: string) => ({
            name: opt.toUpperCase(),
            isActive: false,
            value: opt
          }))
        } else {
          options = Object.entries(result?.data)?.map((opt: any) => ({
            name: opt?.[0].toUpperCase(),
            isActive: false,
            value: opt?.[0],
            icon: (
              <img
                className='mr-2'
                alt='Merah'
                src={opt?.[1]}
                width={25}
                height={25}
                style={{ objectFit: 'contain' }}
              />
            )
          }))
        }
        setDataList(prevs =>
          prevs.map(prev => {
            if (prev.id === rowId) {
              const newPrev = {
                ...prev,
                itemName: '',
                rarity: '',
                option: {
                  ...prev.option,
                  itemName: options
                }
              }
              return newPrev
            }
            return {
              ...prev
            }
          })
        )
      }
    }
    if (fieldName === 'itemName' && !['NON_NFT', 'NON-NFT'].includes(currentItemType as string)) {
      const [error, result]: any = await handleAsyncRequest(guildApi.getRarity(val.value))
      if (error) {
        return
      }
      if (result) {
        const rarityOptions = result.data.map((item: any) => ({
          name: item.display,
          isActive: false,
          value: item.display,
          icon: <img className='mr-2' alt='Merah' src={getImgByKey(item.display)} width={25} />
        }))
        setDataList(prevs =>
          prevs.map(prev => {
            if (prev.id === rowId) {
              const newPrev = {
                ...prev,
                rarity: '',
                option: {
                  ...prev.option,
                  rarity: rarityOptions
                }
              }
              return newPrev
            }
            return {
              ...prev
            }
          })
        )
      }
    }
  }

  const renderRows = (item: DataItem, index: number) => {
    const fieldList = Object.entries(item)
    const checkDisabled = (rowId: number, fieldName: keyof DataItem) => {
      const currentItemType = dataList.find(item => item.id === rowId)?.itemType
      if (['COIN', 'NFT TICKET'].includes(currentItemType as string) && ['itemName', 'rarity'].includes(fieldName)) {
        return 'input-disabled'
      }
      if (['NON-NFT', 'NON_NFT'].includes(currentItemType as string) && ['rarity'].includes(fieldName)) {
        return 'input-disabled'
      }
    }

    const checkQuantityDisabled = (rowId: number) => {
      const currentItemType = dataList.find(item => item.id === rowId)?.itemType
      return 'NFT' === currentItemType
    }

    const validator = (rowId: number, fieldName: keyof DataItem) => {
      const valueInput = dataList?.find((data: DataItem) => data.id === rowId)?.[fieldName]
      if (Number(valueInput) > 2147483647) {
        return 'error-validation'
      }
      return ''
    }

    return (
      <>
        {fieldList
          .filter(item => !['option', 'id'].includes(item?.[0]))
          .map(field => (
            <div key={`${field?.[0]}-${index}`} style={renderWidthByField(field?.[0]) as any}>
              {field?.[0] === 'no' ? (
                index + 1
              ) : field?.[0] === 'quantity' ? (
                <div className='merah'>
                  <InputPrizePool
                    customClass={validator(item.id, field?.[0] as keyof DataItem)}
                    maxLength={16}
                    type='text'
                    onKeyDown={e => _handleKeyDownDay(e, item.id)}
                    onChange={val => actionSelectValue(val, item.id, field?.[0] as keyof DataItem)}
                    value={renderFieldValue(item.id, field?.[0] as keyof DataItem)}
                    heigth={40}
                    width={150}
                    disabled={checkQuantityDisabled(item.id)}
                  />
                </div>
              ) : (
                <div className={`box-select ${checkDisabled(item.id, field?.[0] as keyof DataItem)}`}>
                  <SelectCustomCreateRace
                    dataSelect={renderOptionsValue(item.id, field?.[0] as keyof DataItem)}
                    nameSelect={renderFieldValue(item.id, field?.[0] as keyof DataItem)}
                    onSelected={val => actionSelectValue(val, item.id, field?.[0] as keyof DataItem)}
                    disabled={checkDisabled(item.id, field?.[0] as keyof DataItem) === 'input-disabled'}
                    isShowIcon={['collection', 'rarity', 'itemName'].includes(field?.[0])}
                  />
                </div>
              )}
            </div>
          ))}
        <img
          style={{ cursor: 'pointer', marginRight: '8px' }}
          width={24}
          height={24}
          onClick={handleRemoveItem(item.id)}
          src={DELETE}
          alt='close'
        />
      </>
    )
  }

  const generateNumericId = () => {
    const timestamp = Date.now()
    const randomSuffix = Math.floor(Math.random() * 1000)
    return timestamp * 1000 + randomSuffix
  }

  const handleAddRow = () => {
    setDataList(prev => {
      const nextNo = prev.length > 0 ? Math.max(...prev.map(item => item.no)) + 1 : 1

      const newRecord: DataItem = {
        id: generateNumericId(),
        no: nextNo,
        itemType: '',
        collection: '',
        itemName: '',
        rarity: '',
        quantity: 0,
        option: {
          itemType: optionItemType,
          collection: [],
          itemName: [],
          rarity: []
        }
      }

      return [...prev, newRecord]
    })
  }

  const isValid = useMemo(() => {
    if (!rewardCode.trim()) return false
    if (!dataList.length) return false
    return dataList.every(item => {
      const hasCollection = !!item.collection?.trim()
      const hasItemName = !!item.itemName?.trim()
      const hasRarity = !!item.rarity?.trim()
      const hasQuantity = item.quantity > 0 && item.quantity <= 2147483647

      switch (item.itemType) {
        case 'NFT':
          return hasCollection && hasItemName && hasRarity && hasQuantity
        case 'NON-NFT':
        case 'NON_NFT':
          return hasCollection && hasItemName && hasQuantity
        case 'COIN':
        case 'NFT TICKET':
          return hasCollection && hasQuantity
        default:
          return false
      }
    })
  }, [dataList, rewardCode])

  const handleSave = async () => {
    setLoadingSubmit(true)
    const convertedData = dataList.map(item => {
      const rewardRequest: RewardRequest = {
        amount: Number(item.quantity),
        item_type: '',
        parent_sub_type: ''
      }
      if (item.itemType === 'NFT') {
        rewardRequest.item_type = item.collection
        rewardRequest.parent_sub_type = item.itemName
        rewardRequest.rarity_type = item.rarity
      }
      if (item.itemType === 'NON-NFT' || item.itemType === 'NON_NFT') {
        rewardRequest.item_type = 'BOOSTER'
        rewardRequest.parent_sub_type = item.collection
        rewardRequest.designated_item = item.itemName
      }
      if (item.itemType === 'NFT TICKET' || item.itemType === 'COIN') {
        rewardRequest.item_type = item.itemType === 'NFT TICKET' ? 'TICKET' : 'COIN'
        rewardRequest.parent_sub_type =
          item.collection === 'KUDA' || item.collection === 'MERAH' ? `${item.collection}_NEW` : item.collection
      }
      return rewardRequest
    })
    const payload = {
      guild_id: profile.guild_id,
      package_code: rewardCode.trim(),
      rewards_detail_request_dtos: convertedData
    }
    const [error, result]: any = await handleAsyncRequest(
      inforEdit ? guildApi.postUpdateRewardSetting(inforEdit?.id, payload) : guildApi.postCreateRewardSetting(payload)
    )
    if (error) {
      setLoadingSubmit(false)
      notification.error({
        message: 'ERROR',
        description: (error as any)?.message ?? 'Error',
        placement: 'bottomRight',
        duration: 4,
        className: 'ant-custom-error',
        icon: <></>
      })
      return
    }
    if (result) {
      notification.success({
        message: 'SUCCESS',
        description: inforEdit ? 'Update Reward Template successfully!' : 'Create Reward Template successfully!',
        placement: 'bottomRight',
        duration: 4,
        className: 'ant-custom-success'
      })
      setLoadingSubmit(false)
      onConfirmCreateRaceClick()
      onCloseButtonClick()
    }
  }

  const handleChangeRewardCode = (e: React.ChangeEvent<HTMLInputElement>) => {
    let value = e.target.value
    if (value.length > 25) {
      value = value.slice(0, 25)
    }
    value = value.replace(/\s+/g, ' ').trimStart()
    setRewardCode(value)
  }

  const handleKeyPressRewardCode = (e: React.KeyboardEvent<HTMLInputElement>) => {
    const char = String.fromCharCode(e.charCode || e.which)
    const regex = /^[a-zA-Z0-9 ]$/
    if (!regex.test(char)) {
      e.preventDefault()
      return
    }
    const value = (e.target as HTMLInputElement).value
    if (value.length >= 25) {
      e.preventDefault()
      return
    }
    if (char === ' ' && value.length === 0) {
      e.preventDefault()
      return
    }
    if (char === ' ' && value[value.length - 1] === ' ') {
      e.preventDefault()
      return
    }
  }

  return (
    <Modal>
      <ModalUserCreateRewardSettingStyled>
        {contextHolder}
        <div className='user-create_reward-setting-modal'>
          <button className='close-btn p-0 position-absolute' role='button' onClick={onCloseButtonClick}>
            <img src={CLOSE_BTN} alt='close' />
          </button>
          <div className={`title-create-reward-setting-container`}>
            <div className={`color-primary`}>{inforEdit ? t(`${GUILD_MESSAGE}.editTemplate`) : t(`${GUILD_MESSAGE}.detailSetting`)}</div>
            <img src={TWO_LINE} alt='' />
          </div>
          <div className='create-reward-setting-container'>
            <div className='detail-reward-code-section'>
              <div>{t(`${GUILD_MESSAGE}.rewardCode`)}</div>
              <SearchInput
                searchValue={rewardCode}
                handleSearchValueChanged={handleChangeRewardCode}
                onKeyPress={handleKeyPressRewardCode}
                customClass='search-horse-input'
                placeholder={''}
                isPen
              />
            </div>
            <div className='detail-reward-setting-head border-styled'>
              {headColumns.map(head => (
                <div key={head.title} style={{ width: head.width }} className='head-title'>
                  {!!head.title && t(`${GUILD_MESSAGE}.${head.title}`)}
                </div>
              ))}
            </div>
            <div className='detail-reward-setting-row'>
              {dataList?.map((item, index) => (
                <div className='row-item' key={item.id}>
                  {renderRows(item, index)}
                </div>
              ))}
            </div>
          </div>
          {dataList.length < 12 ? (
            <div>
              <Button
                buttonName={<div>{t(`${GUILD_MESSAGE}.add`)}</div>}
                onClickButton={handleAddRow}
                width={147}
                type='btnSelectAll'
                classNames='btn-add'
                disabled={dataList.length >= 12}
              />
            </div>
          ) : (
            <div style={{ height: '45px', marginTop: '20px' }} />
          )}
          <div className='row line__guild--gradiant'>
            <img src={LINE_GUILD_GRADIENT} />
          </div>
          <div className='action'>
            <Button
              type='btnCancel'
              buttonName={t(`${GUILD_MESSAGE}.cancel`)}
              onClickButton={onCloseButtonClick}
              width={147}
            />
            <Button
              isLoading={loadingSubmit}
              buttonName={t(`${GUILD_MESSAGE}.save`)}
              onClickButton={handleSave}
              disabled={!isValid}
              width={147}
            />
          </div>
        </div>
      </ModalUserCreateRewardSettingStyled>
    </Modal>
  )
}

export default ModalUserCreateRewardSetting
